import { z } from 'zod';

function isEmail(val: string) {
  return z.string().email().safeParse(val).success;
}

function isTelegram(val: string) {
  return /^@?[a-zA-Z0-9_]{4,32}$/.test(val);
}

export const leadMagnetSchema = z.object({
  contact: z
    .string()
    .min(1, 'Укажите email или Telegram')
    .refine(
      (val) => isEmail(val) || isTelegram(val),
      'Не похоже ни на email, ни на @telegram',
    ),
  consent: z.literal(true, {
    error: 'Без согласия на обработку данных отправить не получится',
  }),
});

export type LeadMagnetInput = z.infer<typeof leadMagnetSchema>;

export function detectContactType(contact: string): 'email' | 'telegram' {
  return isEmail(contact) ? 'email' : 'telegram';
}
